// extracted by mini-css-extract-plugin
export default {"container":"container-Avv0ppL2"};